export default [
    {
        value: "Disponivel",
        text: "Disponível",
        variante: "primary",
    },
    {
        value: "Indisponivel",
        text: "Indisponível",
        variante: "danger",
    },
    {
        value: "EmProcesso",
        text: "Em Processo",
        variante: "primary",
    },
    {
        value: "PropostaFechada",
        text: "Proposta Fechada",
        variante: "info",
    },
    {
        value: "PropostaEnviadaAANEEL",
        text: "Proposta Enviada à ANEEL",
        variante: "info",
    },
    {
        value: "ComprovantePropostaArmazenado",
        text: "Comprovante de Proposta Armazenado",
        variante: "info",
    },
    {
        value: "ParecerInicialANEELRecebido",
        text: "Parecer Inicial da ANEEL Recebido",
        variante: "info",
    },
    {
        value: "InteresseEnviadoAANEEL",
        text: "Interesse Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "ComprovanteInteresseArmazenado",
        text: "Comprovante de Interesse Armazenado",
        variante: "info",
    },
    {
        value: "InicioEnviadoAANEEL",
        text: "Início Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "VirouProjeto",
        text: "Virou Projeto",
        variante: "success",
    },
    {
        value: "ProjetoEmExecucao",
        text: "Projeto em Execução",
        variante: "info",
    },
    {
        value: "ElaborarRelatoriosFinais",
        text: "Elaborar Relatórios Finais",
        variante: "info",
    },
    {
        value: "AguardandoRelatoriosFinais",
        text: "Aguardando Relatórios Finais",
        variante: "warning",
    },
    {
        value: "Prorrogado",
        text: "Prorrogado",
        variante: "info",
    },
    {
        value: "ComprovanteProrrogacaoArmazenado",
        text: "Comprovante de Prorrogação Armazenado",
        variante: "info",
    },
    {
        value: "FaseFinal",
        text: "Fase Final",
        variante: "info",
    },
    {
        value: "PDFRelatorioFinalEnviadoAANEEL",
        text: "PDF Relatório Final Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "XMLRelatorioFinalEnviadoAANEEL",
        text: "XML Relatório Final Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "ComprovanteRelatorioFinalPDFArmazenado",
        text: "Comprovante de Relatório Final PDF Armazenado",
        variante: "info",
    },
    {
        value: "ComprovanteRelatorioFinalXMLArmazenado",
        text: "Comprovante de Relatório Final XML Armazenado",
        variante: "info",
    },
    {
        value: "PDFRelatorioAuditoriaEnviadoAANEEL",
        text: "PDF Relatório de Auditoria Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "XMLRelatorioAuditoriaEnviadoAANEEL",
        text: "XML Relatório de Auditoria Enviado à ANEEL",
        variante: "info",
    },
    {
        value: "ComprovanteRelatorioAuditoriaPDFArmazenado",
        text: "Comprovante de Relatório de Auditoria PDF Armazenado",
        variante: "info",
    },
    {
        value: "ComprovanteRelatorioAuditoriaXMLArmazenado",
        text: "Comprovante de Relatório de Auditoria XML Armazenado",
        variante: "info",
    },
    {
        value: "ProjetoEncerrado",
        text: "Projeto Encerrado",
        variante: "success",
    },
    {
        value: "ParecerAneelEmAtraso",
        text: "Parecer ANEEL em Atraso",
        variante: "danger",
    },
    {
        value: "RecebeuGlosaProjetoEmDefesa",
        text: "Recebeu Glosa do Projeto em Defesa",
        variante: "danger",
    },
    {
        value: "DefesaEnviadaAANEEL",
        text: "Defesa Enviada à ANEEL",
        variante: "info",
    },
    {
        value: "ProjetoAprovadoEFinalizado",
        text: "Projeto Aprovado e Finalizado",
        variante: "success",
    },
]
